import React from "react";

const socials = [
    {
        name: "LinkedIn",
        url: "https://linkedin.com",
        icon: "/linkedin.svg",
    },
    {
        name: "Instagram",
        url: "https://instagram.com",
        icon: "/instagram.svg",
    },

];

const images = [
    {
        image: "https://picsum.photos/300/600?random=1",
        alt: "temp Image",
    },
    {
        image: "https://picsum.photos/300/600?random=2",
        alt: "temp Image",
    },
    {
        image: "https://picsum.photos/300/600?random=3",
        alt: "temp Image",
    },
    {
        image: "https://picsum.photos/300/600?random=4",
        alt: "temp Image",
    },
    {
        image: "https://picsum.photos/300/600?random=5",
        alt: "temp Image",
    },
    {
        image: "https://picsum.photos/300/600?random=6",
        alt: "temp Image",
    }
]

const FanMobile: React.FC = () => {
    return (
        <section className="w-full bg-gradient-to-b from-[#A574BFcc] to-transparent py-16 text-white">

            {/* Title */}
            <h2 className="text-3xl text-center mb-8 font-semibold">
                Socials
            </h2>

            {/* Swipe cards */}
            <div className="overflow-x-auto no-scrollbar">
                <div className="flex gap-4 px-5 snap-x snap-mandatory">

                    {images.map((s, i) => (
                        <a
                            key={i}
                            className="min-w-[75%] snap-center relative transition-transform duration-300 hover:scale-105"
                        >
                            <img
                                src={s.image}
                                alt={s.alt}
                                className="w-full h-96 object-cover rounded-2xl"
                            />

                            {/* Overlay */}

                        </a>
                    ))}

                </div>
            </div>

            {/* Footer */}
            <div className="mt-10 text-center text-white/80 space-y-4">
                <p>Follow us on social media</p>
                <div className="flex justify-center gap-6">
                    {socials.map((s, i) => (
                        <a
                            key={i}
                            href={s.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={s.name}
                        >
                            <img
                                src={s.icon}
                                alt={s.name}
                                className="w-12 h-12 filter invert"
                            />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FanMobile;